/* INTEGY V211 — faster predictive search polish + collection thumbnail fallback — 10JUN2026 */
(function(){
  'use strict';
  if (window.INTEGY_V209_LIGHTWEIGHT_PREDICTIVE_SEARCH_LOADED) return;
  window.INTEGY_V209_LIGHTWEIGHT_PREDICTIVE_SEARCH_LOADED = true;
  window.INTEGY_V207_PRIORITY_SEARCH_AND_FILTER_UX_LOADED = true;
  window.INTEGY_V204_ONE_SEARCH_LAYOUT_LOADED = true;
  window.INTEGY_V206_ONE_SEARCH_PRODUCTS_COLLECTIONS = true;
  window.INTEGY_V207_PRIORITY_SEARCH = true;
  window.INTEGY_V206_SEARCH_COLLECTION_FILTER_STABILITY_LOADED = true;

  var docEl = document.documentElement;
  var isMobileLite = false;
  try { isMobileLite = window.matchMedia && window.matchMedia('(max-width: 860px)').matches; } catch(e) {}
  docEl.classList.add('integy-v204-one-search-layout','integy-v206-one-search-products-collections','integy-v207-priority-search-filter-ux','integy-v209-mobile-speed-search','integy-v211-predictive-polish');
  if (isMobileLite) docEl.classList.add('integy-v213-search-mobile-lite');

  var PANEL_ID = 'integy-v204-one-search-panel';
  var READY_ATTR = 'data-integy-v204-one-search-ready';
  var activeInput = null;
  var activeToken = 0;
  var timer = 0;
  var skuCache = Object.create(null);
  var pending = Object.create(null);
  var suggestionCache = Object.create(null);
  var collectionsCache = null;
  var lastPanelHtml = '';
  var currentAbort = null;
  var skuPrefixChunkCache = Object.create(null);
  var skuPrefixChunkPending = Object.create(null);
  var textChunkCache = Object.create(null);
  var textChunkPending = Object.create(null);
  var searchPrewarmed = false;

  var MANUAL_COLLECTIONS = [
    ['All Integy Hop-Up Parts','/collections/all-integy-hop-up-parts','All product upgrades and replacement parts'],
    ['Parts for Arrma','/collections/hopups-for-arrma','Kraton, Outcast, Typhon, Mojave, Granite'],
    ['Parts for Traxxas','/collections/hop-up-parts-for-traxxas','XRT, X-Maxx, Maxx, Slash, TRX-4'],
    ['Parts for Losi','/collections/hopups-for-losi','Promoto-MX, LMT, Baja Rey, Mini-T'],
    ['Hop-up Parts for Losi 1/4 Promoto-MX Motorcycle RTR','/collections/hop-up-parts-for-losi-1-4-promoto-mx-motorcycle-rtr','Promoto-MX motorcycle upgrades'],
    ['Parts for More RC Vehicles','/collections/integy-hop-ups-for-more-rc-vehicles','Mugen, OFNA, Hobao, Yokomo, XRAY and more'],
    ['Parts for Team Associated','/collections/hopups-for-associated','RC10, B5, SC10, RC8'],
    ['Parts for Axial Adventure','/collections/hopups-for-axial','SCX10, SCX24, Capra, Ryft, Wraith'],
    ['Parts for HPI Racing','/collections/hop-up-parts-for-hpi-racing','Savage, Baja, Firestorm, Sprint 2'],
    ['Parts for Tamiya','/collections/hopups-for-tamiya','TT-02, CC-02, F104, semi trucks'],
    ['Parts for Kyosho','/collections/hop-up-parts-for-kyosho','Inferno, Mini-Z, Optima, FW-series'],
    ['Suspension Parts','/collections/suspension-parts','Shocks, arms, hubs, towers, springs'],
    ['Wheels & Tires','/collections/all-tires-wheels-accessories','Wheels, tires, wheel hexes and hubs'],
    ['RC Electronics','/collections/rc-electronics','ESC, servos, motors, fans, wiring'],
    ['RC Tools','/collections/rc-tools','Drivers, wrenches, setup tools'],
    ['Rock Crawler Parts','/collections/rock-crawler-corner','Crawler upgrades and scale parts'],
    ['RC Bodies','/collections/rc-bodies','Bodies and body accessories'],
    ['Hex Allen Wrenches','/collections/hex-allen-wrenches-for-rc-cars-boats-planes-helicopters','Allen wrench sets and replacement blades'],
    ['Servo Horns & Savers','/collections/aluminum-servo-horn-for-rc-cars-boats-planes-helicopters','Aluminum servo horns and servo savers'],
    ['LED Lights','/collections/led-lights','Crawler and scale LED lighting'],
    ['Clearance Up to 80% Off','/collections/on-sale-clearance-up-to-80','Sale and clearance items'],
    ['Scratch & Dent Items','/collections/scratch-dent-items','Open box and scratch and dent items']
  ];

  function qs(sel, root){ try { return (root || document).querySelector(sel); } catch(e){ return null; } }
  function qsa(sel, root){ try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch(e){ return []; } }
  function uniq(arr){ var seen=Object.create(null), out=[]; (arr||[]).forEach(function(v){ v=String(v||''); if(!v || seen[v]) return; seen[v]=true; out.push(v); }); return out; }
  function clean(s){ return String(s || '').replace(/\s+/g,' ').trim(); }
  function compact(s){ return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function norm(s){ return String(s || '').toLowerCase().replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim(); }
  function handleize(v){ v=String(v||'').toLowerCase(); try{v=v.normalize('NFKD').replace(/[\u0300-\u036f]/g,'');}catch(e){} return v.replace(/[’']/g,'').replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,''); }
  function digits(s){ var m = compact(s).match(/\d{2,8}/); return m ? m[0] : ''; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function indexBase(){ return window.INTEGY_FILTER_INDEX_ASSET_BASE || '/cdn/shop/t/0/assets/'; }
  function absUrl(url){ url=String(url||''); if(!url) return ''; if(url.indexOf('//')===0) return location.protocol + url; try { return new URL(url, location.origin).pathname + new URL(url, location.origin).search; } catch(e){ return url; } }
  function normalizeUrl(url){ url=String(url||''); if(url.indexOf('//')===0) return location.protocol + url; return url; }
  function titleizeHandle(h){ return String(h||'').replace(/-/g,' ').replace(/\b\w/g,function(m){return m.toUpperCase();}).replace(/Rc\b/g,'RC').replace(/Esc\b/g,'ESC').replace(/Hpi\b/g,'HPI').replace(/Ofna\b/g,'OFNA').replace(/Xray\b/g,'XRAY'); }

  function removeShortcutRow(){
    qsa('.integy-collections-hub__toolrow,.integy-v203-hub-search-link').forEach(function(el){
      if (!el || el.dataset.integyV204Removed === '1') return;
      el.dataset.integyV204Removed = '1';
      el.setAttribute('aria-hidden','true');
      el.hidden = true;
      el.style.setProperty('display','none','important');
    });
  }

  function fixCollectionDescription(){
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    qsa('.productgrid--masthead,.collection--description,[data-collection-description],.collection--description.rte,.productgrid--masthead .rte,.productgrid--masthead p,.productgrid--masthead h1').forEach(function(el){
      el.dataset.integyV206DescriptionFixed = '1';
      el.style.setProperty('white-space','normal','important');
      el.style.setProperty('max-height','none','important');
      el.style.setProperty('height','auto','important');
      el.style.setProperty('overflow','visible','important');
      el.style.setProperty('overflow-x','visible','important');
      el.style.setProperty('text-overflow','clip','important');
      el.style.setProperty('max-width','min(980px,100%)','important');
      el.style.setProperty('min-width','0','important');
      el.style.setProperty('overflow-wrap','anywhere','important');
    });
  }

  function panel(){
    var p = document.getElementById(PANEL_ID);
    if (p) return p;
    p = document.createElement('div');
    p.id = PANEL_ID;
    p.className = 'integy-v204-one-search-panel';
    p.setAttribute('role','listbox');
    p.setAttribute('aria-label','Search suggestions');
    document.body.appendChild(p);
    return p;
  }

  function formForInput(input){ return input && input.closest ? input.closest('form[action*="/search"],form[role="search"],.integy-collections-hub__search,.live-search-form') : null; }
  function shouldBindInput(input){
    if (!input || !input.matches) return false;
    if (!input.matches('input[type="search"],input[name="q"],input[name="search"],input[name="query"]')) return false;
    var form = formForInput(input);
    if (!form) return false;
    return !!(form.matches('.integy-collections-hub__search,form[action*="/search"],form[role="search"]') || form.closest('header,.site-header,.site-header-main,.site-header-main-content,[data-integy-collections-hub]'));
  }

  function ensureProductType(form){
    if (!form) return;
    var hidden = qs('input[name="type"]', form);
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'type';
      form.appendChild(hidden);
    }
    hidden.value = 'product';
    var input = qs('input[type="search"],input[name="q"]', form);
    var button = qs('button[type="submit"],button:not([type])', form);
    if (form.classList && form.classList.contains('integy-collections-hub__search')) {
      if (input) input.setAttribute('placeholder','Search SKU, product, vehicle, part, or collection...');
      if (button && /search products/i.test(clean(button.textContent))) button.textContent = 'Search';
    }
  }

  function positionPanel(input){
    if (!input) return;
    var form = formForInput(input) || input;
    var rect = (form.getBoundingClientRect ? form.getBoundingClientRect() : input.getBoundingClientRect());
    var inputRect = input.getBoundingClientRect ? input.getBoundingClientRect() : rect;
    var viewport = window.innerWidth || document.documentElement.clientWidth || 1200;
    var gutter = viewport < 750 ? 10 : 8;
    var baseWidth = Math.max(rect.width || 0, inputRect.width || 0, 340);
    var width;
    if (form && form.classList && form.classList.contains('integy-collections-hub__search')) width = Math.min(Math.max(baseWidth, 520), 680, viewport - gutter * 2);
    else width = Math.min(Math.max(baseWidth, 540), 780, viewport - gutter * 2);
    var left = Math.max(gutter, Math.min(rect.left || inputRect.left || gutter, viewport - gutter - width));
    var top = Math.max(54, Math.round(inputRect.bottom + 6));
    if (viewport < 750) {
      width = viewport - gutter * 2;
      left = gutter;
      top = Math.max(58, Math.round(inputRect.bottom + 4));
    }
    var p = panel();
    p.style.setProperty('--integy-v204-search-top', top + 'px');
    p.style.setProperty('--integy-v204-search-left', Math.round(left) + 'px');
    p.style.setProperty('--integy-v204-search-width', Math.round(width) + 'px');
  }

  function hideOldBoxes(form){
    if (form) {
      qsa('.integy-v183-suggest-box,.search-flydown,[data-live-search-flydown],[data-live-search-results],[data-search-flydown],.predictive-search', form).forEach(function(el){
        if (el.id === PANEL_ID) return;
        el.style.setProperty('display','none','important');
        el.setAttribute('aria-hidden','true');
      });
    }
  }

  function openPanel(input){
    activeInput = input;
    positionPanel(input);
    hideOldBoxes(formForInput(input));
    docEl.classList.add('integy-v204-one-search-active');
    if (document.body) document.body.classList.add('integy-v206-search-active');
  }
  function closePanel(){
    docEl.classList.remove('integy-v204-one-search-active');
    if (document.body) document.body.classList.remove('integy-v206-search-active');
    activeInput = null;
    lastPanelHtml = '';
    panel().innerHTML = '';
    if (currentAbort) { try { currentAbort.abort(); } catch(e){} currentAbort = null; }
  }

  function viewAllUrl(q){ return '/search?type=product&q=' + encodeURIComponent(clean(q)); }
  function setHtml(html){ if(html === lastPanelHtml) return; lastPanelHtml = html; panel().innerHTML = html; }
  function loading(q){ setHtml('<div class="integy-v204-one-search-loading">Searching “' + esc(q) + '”…</div>'); }
  function noResults(q){ setHtml('<div class="integy-v204-one-search-empty">No quick suggestions found. <a href="' + esc(viewAllUrl(q)) + '">Search products for “' + esc(q) + '”</a></div>'); }

  function localItemFromArray(a, source){
    a = a || [];
    return {kind:'product',score:0, sku:a[0] || '', title:a[1] || '', url:a[2] || '#', image:a[3] || '', price:a[4] ? ('$' + String(a[4]).replace(/^\$/,'')) : '', source:source || 'v207-local'};
  }
  function skuKeyCandidates(raw){
    var c = compact(raw).toLowerCase();
    var d = digits(raw);
    var keys = [];
    if (c.length >= 2) keys.push(c.slice(0, Math.min(3, c.length)));
    if (d.length >= 2) keys.push(d.slice(0, Math.min(3, d.length)));
    return uniq(keys);
  }
  function firstSearchWord(raw){
    var stop = {for:1,and:1,the:1,with:1,from:1,set:1,kit:1,pair:1,part:1,parts:1,rc:1,car:1,cars:1,truck:1,trucks:1,hop:1,up:1,upgrade:1,replacement:1};
    var words = norm(raw).split(' ').filter(function(w){ return w.length >= 3 && !stop[w]; });
    return words[0] || '';
  }
  function textKeyCandidates(raw){
    var stop = {for:1,and:1,the:1,with:1,from:1,set:1,kit:1,pair:1,part:1,parts:1,rc:1,car:1,cars:1,truck:1,trucks:1,hop:1,up:1,upgrade:1,replacement:1};
    var words = norm(raw).split(' ').filter(function(w){ return w.length >= 2 && !stop[w]; });
    var keys = [];
    words.slice(0,3).forEach(function(w){ var cw = compact(w).toLowerCase(); var k = cw.length === 2 ? cw : cw.slice(0,3); if (k) keys.push(k); });
    return uniq(keys).slice(0,2);
  }
  function fetchJsonItems(url, key, cache, pending){
    if (cache[key]) return Promise.resolve(cache[key]);
    if (pending[key]) return pending[key];
    pending[key] = fetch(url, {credentials:'same-origin', cache:'force-cache'})
      .then(function(r){ return r.ok ? r.json() : {items:[]}; })
      .then(function(j){ cache[key] = (j && j.items) || []; return cache[key]; })
      .catch(function(){ cache[key] = []; return []; });
    return pending[key];
  }
  function loadSkuPrefixChunk(prefix){
    prefix = String(prefix || '').toLowerCase().replace(/[^a-z0-9]/g,'').slice(0,3);
    if (!prefix || prefix.length < 2) return Promise.resolve([]);
    return fetchJsonItems(indexBase() + 'integy-v209-sku-prefix-' + encodeURIComponent(prefix) + '.json', prefix, skuPrefixChunkCache, skuPrefixChunkPending);
  }
  function loadTextChunk(prefix){
    prefix = String(prefix || '').toLowerCase().replace(/[^a-z0-9]/g,'').slice(0,3);
    if (!prefix || prefix.length < 2) return Promise.resolve([]);
    var url = indexBase() + (prefix.length === 2 ? 'integy-v209-text-search-' : 'integy-v207-text-search-') + encodeURIComponent(prefix) + '.json';
    return fetchJsonItems(url, prefix, textChunkCache, textChunkPending);
  }
  function scoreFastProduct(item, raw){
    var q = compact(raw), qd = digits(raw), nq = norm(raw), hq = handleize(raw);
    var sku = compact(item.sku || ''), dsku = digits(item.sku || ''), title = compact(item.title || ''), ntitle = norm(item.title || ''), hurl = handleize(item.url || '');
    var sc = 0;
    if (!q && !nq) return 0;
    if (q && sku === q) sc += 1400;
    if (q && sku.indexOf(q) === 0) sc += 980;
    if (q && sku.indexOf(q) !== -1) sc += 760;
    if (qd && dsku === qd) sc += 1180;
    if (qd && dsku.indexOf(qd) === 0) sc += 920;
    if (qd && dsku.indexOf(qd) !== -1) sc += 760;
    if (q.length >= 3 && title.indexOf(q) !== -1) sc += 360;
    var words = nq.split(' ').filter(function(w){ return w.length > 1; });
    var hits = 0;
    words.forEach(function(w){
      var hw = handleize(w);
      if (ntitle.indexOf(w) !== -1) { sc += 190; hits += 1; }
      else if (hurl.indexOf(hw) !== -1) { sc += 120; hits += .65; }
    });
    if (words.length && hits >= words.length) sc += 420;
    else if (words.length > 1 && hits > 0) sc += Math.round(160 * hits / words.length);
    if (nq && ntitle.indexOf(nq) === 0) sc += 360;
    if (nq && ntitle.indexOf(nq) !== -1) sc += 260;
    if (/shock tower/.test(nq) && /shock tower/.test(ntitle + ' ' + hurl)) sc += 300;
    if (/wheel hex/.test(nq) && /wheel hex/.test(ntitle + ' ' + hurl)) sc += 300;
    return sc;
  }
  function mergeLocalArrays(sets, raw){
    var seen = Object.create(null), out = [];
    sets.forEach(function(list){
      (list || []).forEach(function(a){
        var item = Array.isArray(a) ? localItemFromArray(a, 'v207-local') : a;
        item.score = scoreFastProduct(item, raw);
        if (item.score <= 0) return;
        var key = normalizeUrl(item.url || '') || compact(item.sku || '') || compact(item.title || '');
        if (!key) return;
        if (seen[key]) {
          if (!seen[key].image && item.image) seen[key].image = item.image;
          if (!seen[key].price && item.price) seen[key].price = item.price;
          seen[key].score = Math.max(seen[key].score || 0, item.score || 0);
          return;
        }
        seen[key] = item;
        out.push(item);
      });
    });
    out.sort(function(a,b){ return (b.score || 0) - (a.score || 0) || String(a.sku).localeCompare(String(b.sku)); });
    return out.slice(0, 12);
  }
  function localSearch(q){
    var skuKeys = skuKeyCandidates(q);
    var textKeys = textKeyCandidates(q);
    var tasks = [];
    skuKeys.forEach(function(k){ tasks.push(loadSkuPrefixChunk(k)); });
    textKeys.forEach(function(textKey){ tasks.push(loadTextChunk(textKey)); });
    if (!tasks.length) return Promise.resolve([]);
    return Promise.all(tasks).then(function(sets){ return mergeLocalArrays(sets, q); }).catch(function(){ return []; });
  }

  function money(value){
    if (value == null || value === '') return '';
    if (typeof value === 'string') return value;
    var n = Number(value);
    if (!isFinite(n)) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') { try { return Shopify.formatMoney(n); } catch(e) {} }
    return '$' + (n > 999 ? (n / 100).toFixed(2) : n.toFixed(2));
  }
  function firstVariant(p){ return p && p.variants && p.variants.length ? p.variants[0] : null; }
  function imageFromAny(obj){
    var img = obj && (obj.image || obj.featured_image || obj.featured_media || obj.featuredImage || obj.featured_image_url || (obj.images && obj.images[0]) || (obj.media && obj.media[0]));
    if (typeof img === 'string') return normalizeUrl(img);
    if (img && typeof img === 'object') return normalizeUrl(img.url || img.src || img.originalSrc || img.transformedSrc || (img.preview_image && (img.preview_image.src || img.preview_image.url)) || (img.image && (img.image.src || img.image.url)) || '');
    return '';
  }
  function imageFromProduct(p){ var v=firstVariant(p); return imageFromAny(p) || imageFromAny(v); }
  function productUrl(p){ return normalizeUrl((p && (p.url || p.online_store_url)) || (p && p.handle ? '/products/' + p.handle : '#')); }
  function productSku(p){ var v = firstVariant(p); return (v && (v.sku || v.title)) || (p && p.sku) || ''; }
  function productPrice(p){ return money(p && (p.price || p.price_min || p.priceMin || p.price_minimum)); }
  function collectionUrl(c){ return normalizeUrl((c && (c.url || c.online_store_url)) || (c && c.handle ? '/collections/' + c.handle : '#')); }

  function predictiveBase(){
    if (window.Theme && window.Theme.routes && window.Theme.routes.predictive_search_url) return window.Theme.routes.predictive_search_url;
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root.replace(/\/$/, '') + '/search/suggest';
    return '/search/suggest';
  }

  function bestSrcFromImg(img){
    if (!img) return '';
    var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
    if (src && src.indexOf('data:image') !== 0) return normalizeUrl(src);
    var tmpl = img.getAttribute('data-rimg-template') || img.getAttribute('data-template') || '';
    if (tmpl) return normalizeUrl(tmpl.replace('{size}', '90x').replace('_1x1', '_90x'));
    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    if (srcset) {
      var parts = srcset.split(',').map(function(v){ return v.trim().split(/\s+/)[0]; }).filter(function(v){ return v && v.indexOf('data:image') !== 0; });
      if (parts.length) return normalizeUrl(parts[parts.length - 1]);
    }
    return '';
  }
  function textOf(el){ return clean(el ? (el.textContent || '') : ''); }
  function skuFromText(text){ var m = String(text || '').toUpperCase().match(/\b[A-Z]{0,5}\d{3,7}[A-Z0-9]*\b/); return m ? m[0] : ''; }

  function parsePredictiveHtml(html){
    var out = [], seen = Object.create(null);
    if (!html || !window.DOMParser) return out;
    var doc;
    try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch(e) { return out; }
    qsa('a[href*="/products/"],a[href*="/collections/"]', doc).forEach(function(a){
      var href = normalizeUrl(a.getAttribute('href') || '');
      if (!href || href === '#' || seen[href]) return;
      var isProduct = href.indexOf('/products/') !== -1;
      var isCollection = href.indexOf('/collections/') !== -1;
      if (!isProduct && !isCollection) return;
      var title = textOf(qs('.search-flydown--product-title,.productitem--title,.product-title,[data-product-title],.predictive-search__item-heading,.predictive-search__heading,.collection__item-title', a)) || clean(a.getAttribute('aria-label') || a.getAttribute('title') || textOf(a));
      if (!title || /view all|results for|continue|search for/i.test(title)) return;
      var img = bestSrcFromImg(qs('img', a));
      var price = isProduct ? textOf(qs('.search-flydown--product-price,.price,.productitem--price,[data-price]', a)) : '';
      var sku = isProduct ? (skuFromText(title) || skuFromText(href)) : '';
      seen[href] = true;
      out.push({kind:isProduct ? 'product' : 'collection', score:(isProduct ? 180 : 165) + (img ? 40 : 0), sku:sku, title:title, url:href, image:img, price:price, source:'predictive-html'});
    });
    return out;
  }

  function fallbackHtmlSearch(q, signal){
    if (clean(q).length < 2) return Promise.resolve([]);
    var url = predictiveBase() + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search';
    return fetch(url, {credentials:'same-origin', headers:{'Accept':'text/html'}, signal:signal})
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(parsePredictiveHtml)
      .catch(function(){ return []; });
  }

  function fallbackJsonSearch(q, signal){
    if (clean(q).length < 2) return Promise.resolve([]);
    var url = predictiveBase() + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag,variants.title,variants.sku,vendor';
    return fetch(url, {credentials:'same-origin', headers:{'Accept':'application/json'}, signal:signal})
      .then(function(r){ return r.ok ? r.json() : {}; })
      .then(function(j){
        var results = ((j.resources || {}).results || {});
        var products = (results.products || []).map(function(p){ return {kind:'product',score:150 + (imageFromProduct(p) ? 35 : 0), sku:productSku(p), title:p.title || '', url:productUrl(p), image:imageFromProduct(p), price:productPrice(p), source:'predictive-json'}; });
        var collections = (results.collections || []).map(function(c){ return {kind:'collection',score:175 + (imageFromAny(c) ? 25 : 0), sku:'', title:c.title || c.name || titleizeHandle(c.handle || ''), url:collectionUrl(c), image:imageFromAny(c), price:'', source:'predictive-json'}; });
        return collections.concat(products);
      }).catch(function(){ return []; });
  }

  function fallbackSearch(q, signal){
    var key = norm(q);
    if (suggestionCache[key]) return Promise.resolve(suggestionCache[key]);
    return Promise.all([fallbackHtmlSearch(q, signal), fallbackJsonSearch(q, signal)]).then(function(sets){
      var seen = Object.create(null), out = [];
      sets.forEach(function(list){
        (list || []).forEach(function(item){
          var url = normalizeUrl(item.url || '');
          var key = item.kind + '|' + (url || compact(item.title || '') || compact(item.sku || ''));
          if (!key || key === item.kind + '|') return;
          if (seen[key]) {
            if (!seen[key].image && item.image) seen[key].image = item.image;
            if (!seen[key].sku && item.sku) seen[key].sku = item.sku;
            if (!seen[key].price && item.price) seen[key].price = item.price;
            if ((item.score || 0) > (seen[key].score || 0)) seen[key].score = item.score;
            return;
          }
          seen[key] = item;
          out.push(item);
        });
      });
      out.sort(function(a,b){ return (b.score || 0) - (a.score || 0); });
      suggestionCache[norm(q)] = out.slice(0, 18);
      return suggestionCache[norm(q)];
    }).catch(function(){ return []; });
  }

  function collectionTitleFromAnchor(a){
    return clean(textOf(qs('strong', a)) || textOf(qs('.collection__item-title,.collection-item__title,[data-collection-title]', a)) || textOf(a));
  }
  function addCollection(map, title, url, desc, img, source){
    title = clean(title);
    url = absUrl(url);
    if (!title || !url || url === '/collections' || !/^\/collections\//.test(url)) return;
    url = url.split('?')[0];
    var h = handleize(url.replace(/^\/collections\//,''));
    if (!h || h === 'all') return;
    var key = '/collections/' + h;
    var existing = map[key];
    if (existing) {
      if ((desc || '').length > (existing.desc || '').length) existing.desc = clean(desc);
      if (!existing.image && img) existing.image = img;
      if ((title || '').length > (existing.title || '').length && !/collections$/i.test(title)) existing.title = title;
      return;
    }
    map[key] = {kind:'collection', title:title, url:key, handle:h, image:img || '', desc:clean(desc || ''), score:0, source:source || 'dom'};
  }
  function buildCollectionIndex(){
    var map = Object.create(null);
    MANUAL_COLLECTIONS.forEach(function(c){ addCollection(map, c[0], c[1], c[2], '', 'manual'); });
    qsa('a[href*="/collections/"]').forEach(function(a){
      var href = a.getAttribute('href') || '';
      var title = collectionTitleFromAnchor(a);
      if (!title || /view all collection|browse all collection|home\s*$/i.test(title)) return;
      var desc = textOf(qs('em,p,small', a));
      var img = bestSrcFromImg(qs('img', a));
      addCollection(map, title, href, desc, img, 'dom');
    });
    collectionsCache = Object.keys(map).map(function(k){ return map[k]; });
    return collectionsCache;
  }
  function collectionScore(c, q){
    var nq = norm(q), cq = compact(q), hq = handleize(q);
    if (!nq && !cq) return 0;
    var title = norm(c.title), desc = norm(c.desc), handle = c.handle || handleize(c.url);
    var sc = 0;
    if (handle === hq) sc += 1200;
    if (title === nq) sc += 1100;
    if (handle.indexOf(hq) === 0) sc += 720;
    if (handle.indexOf(hq) !== -1) sc += 520;
    if (title.indexOf(nq) === 0) sc += 680;
    if (title.indexOf(nq) !== -1) sc += 470;
    var words = nq.split(' ').filter(function(w){ return w.length > 1; });
    var hits = 0;
    words.forEach(function(w){ if (title.indexOf(w) !== -1 || handle.indexOf(handleize(w)) !== -1) hits += 1; else if (desc.indexOf(w) !== -1) hits += 0.5; });
    if (words.length) sc += (hits / words.length) * 420;
    if (/promoto/.test(nq) && /promoto/.test(handle + ' ' + title)) sc += 500;
    if (/more rc|more vehicle|mugen|ofna|hobao|yokomo|xray/.test(nq) && /more-rc-vehicles|yokomo|ofna|xray|hobao|mugen/.test(handle + ' ' + title)) sc += 420;
    if (/shock tower|wheel hex|servo horn|hex wrench|led/.test(nq) && (title.indexOf(nq) !== -1 || handle.indexOf(hq) !== -1)) sc += 260;
    return sc;
  }
  function collectionSearch(q){
    var list = collectionsCache || buildCollectionIndex();
    var out = [];
    (list || []).forEach(function(c){
      var sc = collectionScore(c, q);
      if (sc <= 160) return;
      out.push({kind:'collection', score:sc, sku:'', title:c.title, url:c.url, image:c.image || '', price:'', desc:c.desc || 'Collection', source:c.source || 'collection-index'});
    });
    out.sort(function(a,b){ return (b.score || 0) - (a.score || 0) || String(a.title).localeCompare(String(b.title)); });
    return out.slice(0, 6);
  }

  function itemHtml(item){
    var isCollection = item.kind === 'collection';
    var collectionFallbackIcon = '<span class="integy-v204-one-search-noimg integy-v206-one-search-noimg-collection integy-v211-collection-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M4 5.5c0-.83.67-1.5 1.5-1.5h4.3c.46 0 .9.21 1.19.58L12.1 6H18.5c.83 0 1.5.67 1.5 1.5v1H4v-3Zm0 5h16v8c0 .83-.67 1.5-1.5 1.5h-13C4.67 20 4 19.33 4 18.5v-8Z"/></svg></span>';
    var productFallbackIcon = '<span class="integy-v204-one-search-noimg integy-v206-one-search-noimg-product integy-v211-product-icon" aria-hidden="true"></span>';
    var img = item.image ? '<img src="' + esc(item.image) + '" alt="" loading="eager" decoding="async" fetchpriority="high">' : (isCollection ? collectionFallbackIcon : productFallbackIcon);
    var sku = item.sku ? '<span class="integy-v204-one-search-sku">' + esc(item.sku) + '</span>' : '';
    var meta = isCollection ? '<span class="integy-v206-one-search-kind">Collection' + (item.desc ? ' · ' + esc(item.desc) : '') + '</span>' : '';
    return '<a class="integy-v204-one-search-item ' + (isCollection ? 'integy-v206-one-search-item--collection' : 'integy-v206-one-search-item--product') + '" href="' + esc(item.url || '#') + '">' +
      '<span class="integy-v204-one-search-imgwrap">' + img + '</span>' +
      '<span class="integy-v204-one-search-copy">' + sku +
      '<span class="integy-v204-one-search-title">' + esc(item.title || '') + '</span>' + meta +
      (item.price ? '<span class="integy-v204-one-search-price">' + esc(item.price) + '</span>' : '') +
      '</span></a>';
  }
  function groupHtml(title, items, limit){
    if (!items || !items.length) return '';
    return '<div class="integy-v206-one-search-group"><div class="integy-v206-one-search-heading">' + esc(title) + '</div>' + items.slice(0, limit || 8).map(itemHtml).join('') + '</div>';
  }
  function importantWordsForVisuals(text){
    var stop = {for:1,and:1,the:1,with:1,from:1,set:1,kit:1,pair:1,part:1,parts:1,rc:1,car:1,cars:1,truck:1,trucks:1,hop:1,up:1,upgrade:1,replacement:1,collection:1,collections:1,all:1,products:1,product:1};
    return norm(text).split(' ').filter(function(w){ return w.length >= 3 && !stop[w]; }).slice(0,10);
  }
  function productImageForCollection(collection, products, q){
    if (!collection || !products || !products.length) return '';
    var words = importantWordsForVisuals((collection.title || '') + ' ' + (collection.url || '') + ' ' + (q || ''));
    var queryWords = importantWordsForVisuals(q || '');
    var best = null, bestScore = 0;
    products.forEach(function(product){
      if (!product || !product.image) return;
      var hay = norm((product.title || '') + ' ' + (product.sku || '') + ' ' + (product.url || ''));
      var score = 0;
      words.forEach(function(w){ if (hay.indexOf(w) !== -1) score += 4; });
      queryWords.forEach(function(w){ if (hay.indexOf(w) !== -1) score += 5; });
      if (score > bestScore) { bestScore = score; best = product; }
    });
    return best && bestScore >= 4 ? (best.image || '') : '';
  }
  function hydrateCollectionImages(collections, products, q){
    collections = collections || [];
    products = products || [];
    collections.forEach(function(collection){
      if (!collection.image) {
        var img = productImageForCollection(collection, products, q);
        if (img) collection.image = img;
      }
    });
    return collections;
  }
  function fastCachedProducts(q){
    var sets = [];
    Object.keys(skuPrefixChunkCache).slice(-4).forEach(function(k){ if (skuPrefixChunkCache[k] && skuPrefixChunkCache[k].length) sets.push(skuPrefixChunkCache[k]); });
    Object.keys(textChunkCache).slice(-4).forEach(function(k){ if (textChunkCache[k] && textChunkCache[k].length) sets.push(textChunkCache[k]); });
    var cached = suggestionCache[norm(q)] || [];
    if (cached.length) sets.push(cached.filter(function(i){ return i && i.kind !== 'collection'; }));
    if (!sets.length) return [];
    return mergeLocalArrays(sets, q).slice(0,8);
  }

  function renderGroups(collections, products, q, loadingProducts){
    collections = hydrateCollectionImages(collections || [], products || [], q);
    products = products || [];
    var status = loadingProducts ? '<div class="integy-v211-search-status"><span class="integy-v211-search-spinner" aria-hidden="true"></span><span>Searching products, collections, and thumbnails…</span></div>' : '';
    var html = '<div class="integy-v204-one-search-list integy-v205-one-search-has-thumbs integy-v206-one-search-list integy-v211-one-search-list">' +
      status +
      groupHtml('Matching collections', collections, 5) +
      groupHtml('Matching products', products, 8) +
      '</div>' +
      '<a class="integy-v204-one-search-footer" href="' + esc(viewAllUrl(q)) + '">Search all products for “' + esc(q) + '”</a>';
    if (!collections.length && !products.length && !loadingProducts) { noResults(q); return; }
    setHtml(html);
  }
  function mergeProducts(local, remote){
    var seen = Object.create(null), out = [];
    (local || []).concat(remote || []).forEach(function(item){
      if (!item || item.kind === 'collection') return;
      var key = normalizeUrl(item.url || '') || compact(item.sku || '') || compact(item.title || '');
      if (!key) return;
      if (seen[key]) {
        if (!seen[key].image && item.image) seen[key].image = item.image;
        if (!seen[key].sku && item.sku) seen[key].sku = item.sku;
        if (!seen[key].price && item.price) seen[key].price = item.price;
        seen[key].score = Math.max(seen[key].score || 0, item.score || 0);
        return;
      }
      seen[key] = item;
      out.push(item);
    });
    out.sort(function(a,b){ return (b.score || 0) - (a.score || 0); });
    return out.slice(0, 10);
  }
  function mergeCollections(local, remote){
    var seen = Object.create(null), out = [];
    (local || []).concat(remote || []).forEach(function(item){
      if (!item || item.kind !== 'collection') return;
      var key = normalizeUrl(item.url || '') || compact(item.title || '');
      if (!key) return;
      if (seen[key]) {
        if (!seen[key].image && item.image) seen[key].image = item.image;
        if (!seen[key].desc && item.desc) seen[key].desc = item.desc;
        seen[key].score = Math.max(seen[key].score || 0, item.score || 0);
        return;
      }
      seen[key] = item;
      out.push(item);
    });
    out.sort(function(a,b){ return (b.score || 0) - (a.score || 0); });
    return out.slice(0, 6);
  }

  function runSearch(input){
    if (!input || !shouldBindInput(input)) return;
    var q = clean(input.value || '');
    if (q.length < 2) { closePanel(); return; }
    ensureProductType(formForInput(input));
    var token = ++activeToken;
    if (currentAbort) { try { currentAbort.abort(); } catch(e){} }
    currentAbort = window.AbortController ? new AbortController() : null;
    var signal = currentAbort ? currentAbort.signal : undefined;
    openPanel(input);
    var colls = collectionSearch(q);
    var instantProducts = fastCachedProducts(q);
    if (colls.length || instantProducts.length) renderGroups(colls, instantProducts, q, true); else loading(q);
    var localDone = false;
    var localProducts = instantProducts || [];
    localSearch(q).then(function(local){
      if (token !== activeToken || activeInput !== input || clean(input.value || '') !== q) return;
      localDone = true;
      localProducts = local || [];
      if (localProducts.length || colls.length) renderGroups(colls, localProducts, q, true);
    });
    setTimeout(function(){
      if (token !== activeToken || activeInput !== input || clean(input.value || '') !== q) return;
      fallbackSearch(q, signal).then(function(remote){
        if (token !== activeToken || activeInput !== input || clean(input.value || '') !== q) return;
        var remoteProducts = (remote || []).filter(function(i){ return i.kind !== 'collection'; });
        var remoteCollections = (remote || []).filter(function(i){ return i.kind === 'collection'; });
        var products = mergeProducts(localProducts, remoteProducts);
        var collections = mergeCollections(colls, remoteCollections);
        renderGroups(collections, products, q, false);
      }).catch(function(){
        if (token !== activeToken || activeInput !== input || clean(input.value || '') !== q) return;
        renderGroups(colls, localProducts, q, false);
      });
    }, (window.innerWidth || 1200) >= 860 ? (localDone || localProducts.length ? 35 : 55) : (localDone || localProducts.length ? 85 : 120));
    setTimeout(function(){
      if (token !== activeToken || activeInput !== input || clean(input.value || '') !== q) return;
      if (!localDone && colls.length) renderGroups(colls, [], q, true);
    }, 45);
  }

  function instantSearching(input){
    if (!input || !shouldBindInput(input)) return;
    var q = clean(input.value || '');
    if (q.length < 2) { closePanel(); return; }
    try {
      openPanel(input);
      var colls = collectionSearch(q);
      var products = fastCachedProducts(q);
      renderGroups(colls, products, q, true);
    } catch(e) { try { loading(q); } catch(e2) {} }
  }
  function schedule(input, delay){
    clearTimeout(timer);
    instantSearching(input);
    timer = setTimeout(function(){ runSearch(input); }, delay == null ? 6 : delay);
  }
  function bindInput(input){
    if (!shouldBindInput(input) || input.getAttribute(READY_ATTR) === 'true') return;
    input.setAttribute(READY_ATTR, 'true');
    input.setAttribute('autocomplete','off');
    input.setAttribute('autocorrect','off');
    input.setAttribute('spellcheck','false');
    var form = formForInput(input);
    ensureProductType(form);
    if (form) form.addEventListener('submit', function(){ ensureProductType(form); closePanel(); }, true);
  }
  function bindAll(){ qsa('input[type="search"],input[name="q"],input[name="search"],input[name="query"]').forEach(bindInput); }

  document.addEventListener('input', function(e){
    if (!shouldBindInput(e.target)) return;
    bindInput(e.target);
    schedule(e.target, (window.innerWidth || 1200) >= 860 ? 4 : 18);
  }, true);
  document.addEventListener('keyup', function(e){
    if (e.key === 'Escape') { closePanel(); return; }
    if (!shouldBindInput(e.target)) return;
    if (e.key && ['Alt','ArrowRight','ArrowLeft','ArrowUp','ArrowDown','Control','Meta','Shift','Tab','Enter'].indexOf(e.key) !== -1) return;
    schedule(e.target, (window.innerWidth || 1200) >= 860 ? 6 : 22);
  }, true);
  document.addEventListener('focusin', function(e){
    if (!shouldBindInput(e.target)) return;
    bindInput(e.target);
    prewarmSearch();
    if (clean(e.target.value).length >= 2) schedule(e.target, (window.innerWidth || 1200) >= 860 ? 4 : 18);
  }, true);
  document.addEventListener('click', function(e){
    var p = document.getElementById(PANEL_ID);
    if (p && (p === e.target || p.contains(e.target))) return;
    if (shouldBindInput(e.target)) return;
    closePanel();
  }, true);
  window.addEventListener('resize', function(){ if (activeInput) positionPanel(activeInput); }, {passive:true});
  window.addEventListener('scroll', function(){ if (activeInput) positionPanel(activeInput); }, {passive:true});



  function prewarmSearch(){
    if (searchPrewarmed) return;
    searchPrewarmed = true;
    try { panel(); } catch(e) {}
    try { buildCollectionIndex(); } catch(e) {}
  }
  function partFilterDetails(){
    return qsa('details[data-integy-v191-part-filter-details],details[data-integy-v199-static-part-filter-details],details[data-integy-v200-static-part-filter-details]');
  }
  function installPartFilterFinders(){
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    partFilterDetails().forEach(function(details){
      var list = qs('[data-integy-v200-static-part-filter-list],.integy-v200-static-part-filter-list,.integy-v201-static-part-filter-list', details);
      if (!list) return;
      var rows = qsa('a[data-tag-handle],a[data-integy-v201-static-row],a[data-integy-v205-static-row]', list);
      if (rows.length < 12) return;
      rows.forEach(function(row){
        if (!row.getAttribute('data-integy-v207-label')) row.setAttribute('data-integy-v207-label', norm(row.textContent || '') + ' ' + handleize(row.getAttribute('data-tag-handle') || ''));
      });
      var wrap = qs('.integy-v207-part-filter-finder', details);
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'integy-v207-part-filter-finder';
        wrap.innerHTML = '<input type="search" aria-label="Find part filters" placeholder="Find part filters..." autocomplete="off"><button type="button" aria-label="Clear part filter search">×</button><div class="integy-v207-part-filter-no-match" hidden>No matching part filters.</div>';
        details.insertBefore(wrap, list);
        var input = qs('input', wrap), button = qs('button', wrap), note = qs('.integy-v207-part-filter-no-match', wrap);
        var apply = function(){
          var q = norm(input.value || '');
          var visible = 0;
          qsa('a[data-tag-handle],a[data-integy-v201-static-row],a[data-integy-v205-static-row]', list).forEach(function(row){
            var active = /(^|\s)is-active(\s|$)/.test(row.className || '') || row.getAttribute('aria-checked') === 'true';
            var hay = row.getAttribute('data-integy-v207-label') || norm(row.textContent || '');
            var show = !q || active || hay.indexOf(q) !== -1 || q.split(' ').every(function(w){ return hay.indexOf(w) !== -1; });
            row.hidden = !show;
            row.style.display = show ? '' : 'none';
            if (show) visible += 1;
          });
          if (note) note.hidden = !!visible;
          wrap.classList.toggle('is-filtering', !!q);
        };
        input.addEventListener('input', apply, {passive:true});
        button.addEventListener('click', function(){ input.value=''; apply(); input.focus(); });
      }
    });
  }

  function boot(){
    removeShortcutRow();
    fixCollectionDescription();
    bindAll();
    qsa('.integy-collections-hub__search').forEach(ensureProductType);
    if (!isMobileLite) installPartFilterFinders();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  if (!isMobileLite) {
    window.addEventListener('load', boot, {passive:true});
    [120,520,1400].forEach(function(ms){ setTimeout(boot, ms); });
    try {
      var moTarget = document.querySelector('.productgrid--sidebar,[data-productgrid-sidebar],[data-integy-collections-hub],.integy-collections-hub');
      if (moTarget) {
        var moTimer = 0;
        new MutationObserver(function(){ clearTimeout(moTimer); moTimer = setTimeout(function(){ collectionsCache = null; boot(); }, 220); }).observe(moTarget, {childList:true, subtree:true});
      }
    } catch(e) {}
  }
})();
